import React, { useCallback } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { AptorApi, useAptorApi } from '../../../../../../Api';
import { EditChecklist, IChecklistItem } from '../../../../../AptorAdmin/Components/Checklist';

interface IRequirementChecklist {
  requirement: string;
  items: IChecklistItem[];
}

export const EditRequirementChecklist = () => {
  const params = useParams<{ reqid: string; unitid: string }>();
  const reqid = parseInt(params.reqid!);
  const unitid = parseInt(params.unitid!);
  const location = useLocation();
  const { api, abortController } = useAptorApi();
  const backTo = location.pathname.startsWith('/law-portal/settings')
    ? `/law-portal/settings/other-requirements/${reqid}/company-units/${unitid}`
    : `/organization/law-portal/other-requirements/${reqid}/company-units/${unitid}`;
  
  const fetcher = useCallback(
    () =>
      api.getRequirementChecklist<IRequirementChecklist>(reqid, unitid).then((x) => {
        if (abortController.current.signal.aborted) {
          return undefined;
        }
        return { name: x.requirement, items: x.items };
      }),
    [api, abortController, reqid, unitid],
  );

  const editor = (api: AptorApi, checklist: { items: IChecklistItem[] }) =>
    api.editRequirementChecklist(reqid, unitid, checklist);

  return (
    <EditChecklist
      fetcher={fetcher}
      editor={editor}
      backTo={backTo}
    />
  );
};
